import React from "react";
import { ConfirmationModal, Typography } from "@platform/design-system";

interface ConfirmDeletePlanDialogProps {
  planGroupId: string;
  planName: string;
  title?: string;
  willPromote?: boolean;
  onConfirm: (planGroupId: string) => void;
  onCancel?: VoidFunction;
}

export const ConfirmDeletePlanDialog: React.FC<
  ConfirmDeletePlanDialogProps
> = ({
  planGroupId,
  planName,
  title = "Delete Plan Group",
  willPromote = false,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm = (): void => {
    onConfirm(planGroupId);
  };

  return (
    <ConfirmationModal
      open
      onCancel={onCancel || (() => {})}
      onAccept={handleConfirm}
      title={title}
      description="This action cannot be undone."
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      additionalMessage={
        <>
          <Typography component="span">
            Are you sure you want to delete <strong>{planName}</strong>?
          </Typography>
          {willPromote && (
            <Typography component="p" sx={{ mt: 1 }}>
              <strong>
                This is the last plan with the current policy period. An
                alternate plan will be promoted to replace it.
              </strong>
            </Typography>
          )}
        </>
      }
    />
  );
};

// Set display name for better debugging
ConfirmDeletePlanDialog.displayName = "ConfirmDeletePlanDialog";
export default ConfirmDeletePlanDialog;
